import { render, staticRenderFns } from "./comp_AnimalPicSection.vue?vue&type=template&id=35ae886f&scoped=true&"
import script from "./comp_AnimalPicSection.vue?vue&type=script&lang=js&"
export * from "./comp_AnimalPicSection.vue?vue&type=script&lang=js&"
import style0 from "./comp_AnimalPicSection.vue?vue&type=style&index=0&id=35ae886f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ae886f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
